module.exports = __webpack_public_path__ + "img/youtube.3f8a291.svg";